import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";

import DataList from "./DataList";

import { Grid, TextField } from "@material-ui/core";

class DataListWithSearchFilter extends Component {
  state = {
    searchQuery: "",
  };

  filter = (item) => {
    let target = "";

    Object.keys(item).forEach((key) => {
      target += typeof item[key] === "string" ? ` ${item[key]}` : "";
    });

    return target.toLowerCase().includes(this.state.searchQuery.toLowerCase());
  };

  handleChange = (e) => this.setState({ [e.target.name]: e.target.value });

  render() {
    return (
      <Fragment>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12}>
            <TextField
              id="searchQuery"
              name="searchQuery"
              label="Zoekfilter"
              value={this.state.searchQuery}
              onChange={this.handleChange}
              fullWidth
            />
          </Grid>
        </Grid>

        <DataList {...this.props} data={this.props.data.filter(this.filter)} />
      </Fragment>
    );
  }
}

DataListWithSearchFilter.propTypes = {
  data: PropTypes.array.isRequired,
};

export default DataListWithSearchFilter;



// WEBPACK FOOTER //
// ./src/components/DataListWithSearchFilter.js